"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCombobox = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ComboboxMixin = require("../../mixins/components/ComboboxMixin");
var StyledCombobox = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledCombobox",
  componentId: "c11n-8-107-0__sc-1tu6hwf-0"
})(["", ""], _ComboboxMixin.ComboboxMixin);
exports.StyledCombobox = StyledCombobox;